import React from "react";
import CustomFilter from "../../../../components/customFilter/CustomFilter";
import avatar from "../../../../icons/farmerAvatar.svg";

function VisitInfo({ title }) {
  return (
    <div className="flex flex-col font-body bg-white p-3 rounded-xl ">
      <section className="flex flex-col border-solid border-[#E3E3E3] border-2 p-2 gap-4 rounded-xl">
        <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row justify-between items-center gap-32 max-lg:flex-col max-lg:gap-5 max-lg:items-start">
            <h2 className="font-semibold text-[2rem]  max-lg:text-[1rem] whitespace-nowrap">
              {title}
            </h2>
            <div className="flex flex-row gap-2 text-[1rem] max-lg:text-[0.75rem] max-lg:font-normal max-lg:text-justify font-semibold">
              <p>کشاورز:</p>
              <p>علیرضا رضائی</p>
            </div>
            <div className="flex flex-row gap-2 text-[1rem] font-semibold max-lg:text-[0.75rem] max-lg:font-normal max-lg:text-justify">
              <p>کد کشاورزی:</p>
              <p>FALRE499451</p>
            </div>
          </div>
          <div className="bg-slate-400 rounded-full overflow-hidden w-[4.375rem] h-[4.375rem]">
            <img alt="avatar" src={avatar} />
          </div>
        </div>
        <div>
          <CustomFilter />
        </div>
      </section>
    </div>
  );
}

export default VisitInfo;
